module.exports = __webpack_public_path__ + "static/media/nlep.6f6de878.png";